import { toast } from 'react-toastify';

import { callApi } from '../../../../apiCaller';
import { sortOrgMemberRole, toastError } from '../../../../utils';
import {
     API_SUBSCRIBER_ORGANIZATION_TRAINING_GROUP_DETAIL,
     API_SUBSCRIBER_ORGANIZATION_TRAINING_GROUP_USER_CHANGE,
     API_SUBSCRIBER_ORGANIZATION_TRAINING_GROUP_USER_CREATE,
     API_SUBSCRIBER_ORGANIZATION_USER_MEMBER,
     API_SUBSCRIBER_TRAINING_GROUP,
     SUBSCRIBER_PATH,
} from '../../../../constants';

import { setOrganizationMembers } from '../OrganizationMembers/actions';
import { setOrganizationSeatsFilter } from '../ManageSeats/OrganizationSeats/actions';
import { setShowPopup } from '../../../../actions/general';

export const API_SUBSCRIBER_TRAINING_GROUP_DATA_LISTS = 'training-groups/data-lists';
export const SET_ORGANIZATION_TRAINING_GROUPS = 'setOrganizationTrainingGroups';

export const setOrganizationTrainingGroups = (orgTrainingGroups) => {
     return {
          type: SET_ORGANIZATION_TRAINING_GROUPS,
          payload: orgTrainingGroups,
     };
};

export const fetchTrainingGroupDataListRequest = (paginationPayload, nextDispatch) => () => {
     const { setTrainingGroupList, initErrors, setIsLoading } = nextDispatch;
     const { filter, page, pageSize, sortBy, sortType } = paginationPayload;
     const filterQuery = Object.keys(filter).length ? `&filter=${encodeURIComponent(JSON.stringify(filter))}` : '';

     callApi(
          `${API_SUBSCRIBER_TRAINING_GROUP_DATA_LISTS}?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortType=${sortType}${filterQuery}`,
          'GET'
     ).then((response) => {
          setIsLoading(false);

          if (response.status !== 200) {
               toastError(response);
               return;
          }

          initErrors(response.data.length);
          setTrainingGroupList(response.data);
     });
};

export const fetchOrgTrainingGroupsRequest = (organizationId) => (dispatch) => {
     callApi(API_SUBSCRIBER_ORGANIZATION_TRAINING_GROUP_DETAIL.replace(':organizationId', organizationId), 'GET').then((response) => {
          if (response.status === 200) {
               dispatch(setOrganizationTrainingGroups(response.data));
          } else {
               toastError(response);
          }
     });
};

export const updateMemberOfTrainingGroupsRequest = (organizationId, countMemberOfTrainingGroup) => (dispatch) => {
     callApi(API_SUBSCRIBER_ORGANIZATION_TRAINING_GROUP_DETAIL.replace(':organizationId', organizationId), 'PUT', countMemberOfTrainingGroup).then(
          (response) => {
               if (response.status === 200) {
                    dispatch(setOrganizationTrainingGroups(response.data));
               } else {
                    toastError(response);
               }
          }
     );
};

export const proceedToRemoveOrgMemberRequest = (id, nextDispatch) => (dispatch, getState) => {
     const organizationMemberUsers = getState().subscriber.organizationMembers;

     const { navigate, updateMemberOfTrainingGroups, setRemoveLoading, setShowRemovePopup } = nextDispatch;

     setRemoveLoading(true);

     callApi(API_SUBSCRIBER_ORGANIZATION_USER_MEMBER.replace(':organizationId', id), 'DELETE')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               if (organizationMemberUsers?.length) {
                    const newOrganizationMemberUsers = organizationMemberUsers.filter(({ orgUserId }) => orgUserId !== id);

                    dispatch(setOrganizationMembers(newOrganizationMemberUsers));
                    updateMemberOfTrainingGroups(newOrganizationMemberUsers);
               }

               navigate(SUBSCRIBER_PATH.ORGANIZATIONS_ORG_MEMBERS);

               toast.success('Delete successfully');
          })
          .finally(() => {
               setRemoveLoading(false);
               setShowRemovePopup(false);
          });
};

export const addNewTrainingGroup = (values, nextDispatch) => (dispatch, getState) => {
     const { setSubmitting, listTrainingGroup, memberSelected, setListTrainingGroup, handleChangeMultiSelect, setLoadingCreatePopup } = nextDispatch;
     const trainingGroups = getState().subscriber.organizationTrainingGroups;

     setSubmitting(true);
     setLoadingCreatePopup(true);

     callApi(API_SUBSCRIBER_TRAINING_GROUP, 'POST', values).then((response) => {
          setSubmitting(false);

          if (response.status !== 200) {
               setLoadingCreatePopup(false);
               toastError(response);
               return;
          }

          const trainingGroup = response.data;
          trainingGroups.unshift(trainingGroup);
          dispatch(setOrganizationTrainingGroups(trainingGroups));
          if (typeof setListTrainingGroup === 'function' && listTrainingGroup) {
               const newList = [...listTrainingGroup];

               const newOption = {
                    label: trainingGroup.name,
                    value: trainingGroup.id,
               };

               newList.unshift(newOption);
               setListTrainingGroup(newList);

               const memberTrainingGroupIds = memberSelected?.trainingGroupIds || [];
               const optionsMemberSelected = newList.filter((option) => memberTrainingGroupIds.includes(option.value));
               optionsMemberSelected.unshift(newOption);

               handleChangeMultiSelect(optionsMemberSelected, memberSelected);
          }

          setLoadingCreatePopup(false);
          dispatch(setShowPopup());
     });
};

export const changeTrainingGroupUser = (organizationId, payload, nextDispatch) => async (dispatch, getState) => {
     const { valuesAdd, valuesRemove } = payload;
     const { orgSeats, seatMember, setOrgSeats, setDisableOptions, setIsLoadingChangeGroups } = nextDispatch;

     const organizationSeatsFilter = getState().subscriber.organizationSeatsFilter;
     const organizationMemberUsers = getState().subscriber.organizationMembers;

     setDisableOptions(true);
     setIsLoadingChangeGroups(true);

     return await callApi(API_SUBSCRIBER_ORGANIZATION_TRAINING_GROUP_USER_CHANGE.replace(':organizationId', organizationId), 'POST', payload)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const trainingGroupsRes = response.data;
               const newOrgSeatRows = [...orgSeats.rows];

               for (let i = 0; i < newOrgSeatRows.length; i++) {
                    const newOrgSeatRow = newOrgSeatRows[i];
                    if (newOrgSeatRow.userId !== seatMember.userId) {
                         continue;
                    }

                    if (valuesAdd.length) {
                         newOrgSeatRows[i].user.trainingGroups = newOrgSeatRow.user.trainingGroups.concat(trainingGroupsRes);
                    } else if (valuesRemove.length) {
                         newOrgSeatRows[i].user.trainingGroups = newOrgSeatRow.user.trainingGroups.filter(
                              (item) => !trainingGroupsRes.includes(item.id)
                         );
                    }
               }

               if (organizationSeatsFilter?.length) {
                    for (let i = 0; i < organizationSeatsFilter.length; i++) {
                         const member = organizationSeatsFilter[i];
                         if (member.userId !== seatMember.userId) {
                              continue;
                         }

                         if (valuesAdd.length) {
                              organizationSeatsFilter[i].user.trainingGroups = member.user.trainingGroups.concat(trainingGroupsRes);
                         } else if (valuesRemove.length) {
                              organizationSeatsFilter[i].user.trainingGroups = member.user.trainingGroups.filter(
                                   (item) => !trainingGroupsRes.includes(item.id)
                              );
                         }
                    }
               }

               const newOrganizationMemberUsers = organizationMemberUsers.map((orgUser) => {
                    const trainingGroups = organizationSeatsFilter?.find((orgSeat) => orgSeat?.user?.id === orgUser.id)?.user?.trainingGroups || [];
                    const trainingGroupIds = trainingGroups.map((trainingGroup) => trainingGroup.id);
                    orgUser.trainingGroupIds = trainingGroupIds;
                    return orgUser;
               });

               setOrgSeats({ count: orgSeats.count, rows: newOrgSeatRows });
               dispatch(setOrganizationSeatsFilter(organizationSeatsFilter));
               dispatch(setOrganizationMembers(sortOrgMemberRole(newOrganizationMemberUsers)));

               return trainingGroupsRes;
          })
          .finally(() => {
               setDisableOptions(false);
               setIsLoadingChangeGroups(false);
          });
};

export const addTrainingGroupUser = (organizationId, payload, nextDispatch) => (dispatch, getState) => {
     const { setSubmitting, listTrainingGroup, seatMember, setListTrainingGroup, handleChangeMultiSelect, setLoadingCreatePopup } = nextDispatch;

     const organizationSeatsFilter = getState().subscriber.organizationSeatsFilter;
     const trainingGroups = getState().subscriber.organizationTrainingGroups;
     const organizationMemberUsers = getState().subscriber.organizationMembers;

     setSubmitting(true);
     setLoadingCreatePopup(true);

     callApi(API_SUBSCRIBER_ORGANIZATION_TRAINING_GROUP_USER_CREATE.replace(':organizationId', organizationId), 'POST', payload).then((response) => {
          setSubmitting(false);

          if (response.status !== 200) {
               setLoadingCreatePopup(false);
               toastError(response);
               return;
          }

          //add Training Group on Redux
          const trainingGroup = response.data;
          trainingGroups.unshift(trainingGroup);
          dispatch(setOrganizationTrainingGroups(trainingGroups));

          //Add list training group IDs
          const newList = [...listTrainingGroup];

          const newOption = {
               label: trainingGroup.name,
               value: trainingGroup.id,
          };

          newList.unshift(newOption);
          setListTrainingGroup(newList);

          const memberTrainingGroupIds = seatMember?.trainingGroupIds || [];
          const optionsMemberSelected = newList.filter((option) => memberTrainingGroupIds.includes(option.value));
          optionsMemberSelected.unshift(newOption);

          handleChangeMultiSelect(optionsMemberSelected, seatMember);

          //add Seats
          if (organizationSeatsFilter?.length) {
               for (let i = 0; i < organizationSeatsFilter.length; i++) {
                    const member = organizationSeatsFilter[i];
                    if (member.userId === seatMember.userId) {
                         organizationSeatsFilter[i].user.trainingGroups.unshift(trainingGroup);
                    }
               }
          }

          dispatch(setOrganizationSeatsFilter(organizationSeatsFilter));

          const newOrganizationMemberUsers = organizationMemberUsers.map((orgUser) => {
               const trainingGroups = organizationSeatsFilter.find((orgSeat) => orgSeat?.user?.id === orgUser.id)?.user?.trainingGroups || [];
               const trainingGroupIds = trainingGroups.map(({ id }) => id);
               orgUser.trainingGroupIds = trainingGroupIds;
               return orgUser;
          });

          dispatch(setOrganizationMembers(sortOrgMemberRole(newOrganizationMemberUsers)));
          setLoadingCreatePopup(false);
          dispatch(setShowPopup());
     });
};
